module.exports = __webpack_public_path__ + "img/glossary-kouzui.cb7880d6.png";